<template>
    <div>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        perm_perfilacessotelas.create &&
                        perm_perfilacessotelas.update
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div>
            <GroupSelector
                :listLeft="listLeftUsers"
                :listRight="listRightUsers"
                fieldName="nome"
                @movedToListRight="movedToListRight($event)"
                @movedToListLeft="movedToListLeft($event)"
                fieldExtraInformation="nomePerfilAcesso"
                groupOneLabel="label-usuarios-desabilitados-kmauto"
                groupTwoLabel="label-usuarios-habilitados-kmauto"
                groupTwoInfo="alert-somente-apos-inserido"
            />
        </div>
    </div>
</template>
<script>
import GroupSelector from '@/components/shared/GroupSelector.vue';

export default {
    name: 'Usuarios',
    components: {
        GroupSelector,
    },
    props: {
        perm_perfilacessotelas: {
            type: Object,
            default: () => {},
        },
        perfil: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isLoading: false,
            isSaving: false,
            usuariosPerfilCorreto: [],
            listLeftUsers: [], //Lista principal da esquerda
            listRightUsers: [], //Lista principal da direita
            addedLeftUsersSelected: [], //Lista de selecionados da esquerda
            addedRightUsersSelected: [], //Lista de selecionados da direita
            listOfChangedValues: [],
        };
    },
    created() {
        this.findAllUser();
    },
    methods: {
        movedToListRight(itens) {
            this.addedLeftUsersSelected = [...this.addedLeftUsersSelected, ...itens];
            this.listRightUsers = [...this.listRightUsers, ...itens];

            // Remove as duplicidade da lista principal da esquerda para quando ficar movendo
            // os itens de um lado para o outro não duplicar
            this.listLeftUsers = this.removeDuplicatesToListMain(
                this.listLeftUsers,
                this.addedLeftUsersSelected
            );

            // Remove as duplicidade da lista de selecionados da esquerda para
            // quando ficar movendo os itens não duplicar
            this.addedLeftUsersSelected =
                this.romoveDuplicatesToListItensSelected(
                    this.addedLeftUsersSelected
                );

            // Esse metodo é utilizado para manter apenas os itens que de fato tiveram uma alteração
            // ou seja, que foram movidos de um lado para o outro e serão alterados seus perfis
            // caso a movimentação seja de um lado para o outro e depois de volta,
            // o item não será adicionado a lista de alterados
            this.addedLeftUsersSelected = this.addedLeftUsersSelected.filter(
                (item) => item.idperfilacesso != Number(this.$route.params.id)
            );

            // Esse filtro garante que itens que foram movido de volta para sua lista de origem serão removidos da addedRightUsersSelected.
            // Caso um item seja movido para a esquerda e depois novamente para a direita, ele será removido da lista de selecionados da direita.
            this.addedRightUsersSelected = this.addedRightUsersSelected.filter(
                itemRightSelected => !itens.some(item => itemRightSelected.id === item.id)
            );
        },
        movedToListLeft(itens) {
            this.addedRightUsersSelected = [...this.addedRightUsersSelected, ...itens];
            this.listLeftUsers = [...this.listLeftUsers, ...itens];

            // Remove as duplicidade da lista principal da direita para quando ficar movendo
            // os itens de um lado para o outro não duplicar
            this.listRightUsers = this.arrayToStringAndBack(this.removeDuplicatesToListMain(
                this.listRightUsers,
                this.addedRightUsersSelected
            ));

            // Remove as duplicidade da lista de selecionados da direita para
            // quando ficar movendo os itens não duplicar
            this.addedRightUsersSelected =
                this.romoveDuplicatesToListItensSelected(
                    this.addedRightUsersSelected
                );

            // Esse metodo é utilizado para manter apenas os itens que de fato tiveram uma alteração
            // ou seja, que foram movidos de um lado para o outro e serão alterados seus perfis
            // caso a movimentação seja de um lado para o outro e depois de volta,
            // o item não será adicionado a lista de alterados
            this.addedRightUsersSelected = this.addedRightUsersSelected.filter(
                (item) => item.idperfilacesso === Number(this.$route.params.id)
            );

            // Esse filtro garante que itens que foram movido de volta para sua lista de origem serão removidos da addedLeftUsersSelected.
            // Caso um item seja movido para a direita e depois novamente para a esquerda, ele será removido da lista de selecionados da esquerda.
            this.addedLeftUsersSelected = this.addedLeftUsersSelected.filter(
                itemLeftSelected => !itens.some(item => itemLeftSelected.id === item.id)
            );
        },

        // Esse metodo é responsável por juntar os itens das listas add addedLeftUsersSelected e addedRightUsersSelected em uma só
        // alterando o idperfilacesso de acordo com o lado transferido
        mergingList(itens1, itens2) {
            itens1.map((item) => (item.idperfilacesso = Number(this.$route.params.id)));
            itens2.map(
                (item) => (item.idperfilacesso = 0)
            );

            this.listOfChangedValues = [...itens1, ...itens2];

            this.listOfChangedValues = this.romoveDuplicatesToListItensSelected(
                this.listOfChangedValues
            );
            return this.listOfChangedValues;
        },
        removeDuplicatesToListMain(arr1, arr2) {
            // Cria um conjunto de ids a partir do segundo array
            const idsToRemove = new Set(arr2.map((obj) => obj.id));

            // Filtra o primeiro array para remover objetos com ids presentes no conjunto
            return arr1.filter((obj) => !idsToRemove.has(obj.id));
        },
        romoveDuplicatesToListItensSelected(array) {
            // Remove os duplicados da lista de selecionados
            return array.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id));
        },

        findAllUser() {
            // busca os usuários, caso quem esteja nessa tela não seja admin
            // não virá os usuários do perfil admin
            this.isLoading = true;
            this.$axios
                .get(`/employees/all-no-limit.json?param=&keepadmin=false`)
                .then((response) => {
                    if (!this.isNull(response.data.content)) {
                        // Preenche dados de todos os usuario que não sejam do perfil atual
                        this.listLeftUsers = response.data.content.filter(
                            (f) => f.idperfilacesso != +this.$route.params.id
                        );
                        // Preenche dados de todos os usuario que sejam do perfil atual
                        this.listRightUsers = response.data.content.filter(
                            (f) => f.idperfilacesso == +this.$route.params.id
                        );
                    }
                })
                .catch((e) => {
                    console.error(
                        'Ocorreu um erro ao buscar dados dos usuarios: ',
                        { e }
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                    //this.findAllUserByPerfil();
                });
        },
        // findAllUserByPerfil() {
        //     // busca os usuários do perfil atual
        //     this.isLoading = true;
        //     this.$axios
        //         .get(`employees/byperfil.json?idperfil=${this.$route.params.id}`)
        //         .then((response) => {
        //             this.selectedUsers = response.data.content;
        //         })
        //         .catch((e) => {
        //             console.error('Ocorreu um erro ao buscar dados dos usuarios: ', { e });
        //         })
        //         .finally(() => {
        //             this.isLoading = false;
        //             this.$store.commit('removeLoader');
        //         });
        // },
        save() {
            // não remove usuários, somente adiciona novos caso tenha adicionado algum a lista
            this.isSaving = true;
            //const usersUpdateList = [];
            this.$axios
                .post(
                    'employees/access-profile/usuarios',
                    (this.listOfChangedValues = this.mergingList(
                        this.addedLeftUsersSelected,
                        this.addedRightUsersSelected
                    ))
                )
                .then((response) => {
                    if (response.data.content) {
                        this.$emit('isChanged', false);
                        this.$root.showMessage('success', 'msg-perfil-editado');
                    } else {
                        if (this.$t(response.data.message)) {
                            this.$root.showMessage(
                                'error',
                                response.data.message
                            );
                        } else {
                            this.$root.showMessage(
                                'error',
                                'msg-problema-realizar-acao'
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage(
                        'error',
                        'msg-problema-realizar-acao'
                    );
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
    },
};
</script>
